var endpointMap = {
	und: {
		"pages.homepage": "translation.json",
		"pages.nav": "translation.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
